import { apiDomain } from '@/lib/config'
import { isMobile } from '@/lib/device'
import Vue from 'vue'
import Cookies from 'js-cookie'

// 如果已经登录，却尝试访问这些页面，将重定向为原本的页面
export const afterLoginBlackListPath = [
  '/account/register',
  '/account/setuser',
  '/account/login',
  '/account/findpwd',
  // '/organization/invitejoinfirst',
  '/organization/invitejoin',
  '/organization/invitejoin2',
  // '/teamwork/invitejoinfirst',
  '/teamInvite/login',
  '/teamInvite/success'
]

// 未登录,进入这些页面，将正常访问，进入的不是这些页面将重定向到登陆页
export const beforeLoginWhiteListPath = [
  '/account/register',
  '/account/login',
  '/account/findpwd',
  '/api/',
  '/organization/invitejoinfirst',
  '/organization/invitejoin',
  '/organization/invitejoin2',
  '/organization/invitejoinlose',
  '/teamwork/invitejoinfirst',
  '/teamInvite/success',
  '/teamInvite/login',
  '/teamInvite/lose'
]

// 判断设备微信，企业微信，钉钉
export const getUaType = () => {
  let uaType = ''
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') !== -1) {
    if (ua.indexOf('wxwork') !== -1) {
      uaType = 'isWxWork'
    } else {
      uaType = 'isWeChat'
    }
  } else if (ua.match('dingtalk')) {
    uaType = 'isDingTalk'
  }
  return uaType
}

// 根据ua判断登陆授权
export const uaTypeLandingAuthorization = () => {
  const uaType = getUaType()
  const fromUrl = window.location.href

  switch (uaType) {
    case 'isWxWork':
      window.location.href = `${apiDomain}/user/wework/applogin?from=${encodeURIComponent(
        fromUrl
      )}`
      break
    case 'isWeChat':
      window.location.href = `${apiDomain}/user/wechat/login?from=${encodeURIComponent(
        fromUrl
      )}`
      break
    case 'isDingTalk':
      const isDing = window.location.hostname.indexOf('dtwork') > -1
      // const dingArg = window.location.hostname.indexOf('dtwork') > -1 ? 'dingtalkservice' : 'dingtalk'
      if (isDing) {
        const corpid = Vue.prototype.$getQueryString('corpId')
        if (Cookies.get('dingTalk')) {
          Cookies.remove('dingTalk')
        }
        if (corpid) {
          // console.log(`${apiDomain}/user/dingtalkservice/login?corpId=${corpid}&isauth=1&from=${encodeURIComponent(
          //   fromUrl
          // )}`)
          window.location.href = `${apiDomain}/user/dingtalkservice/login?corpId=${corpid}&isauth=1&from=${encodeURIComponent(
            fromUrl
          )}`
        } else {
          window.location.href = `${apiDomain}/user/dingtalkservice/login?isauth=1&from=${encodeURIComponent(
            fromUrl
          )}`
        }
      } else {
        window.location.href = `${apiDomain}/user/dingtalk/login?isauth=1&from=${encodeURIComponent(
          fromUrl
        )}`
      }
      // window.location.href = `${apiDomain}/user/${dingArg}/login?isauth=1&from=${encodeURIComponent(
      //   fromUrl
      // )}`
      break
  }
}

// 如果是从企业微信，微信，钉钉点开，询盘详情
export const setReplyPositionQuery = () => {
  let urlFollowupid = Vue.prototype.$getQueryString('followupid') || '' // 回访id
  let urlCommentid = Vue.prototype.$getQueryString('commentid') || '' // 评论id
  let urlReplyid = Vue.prototype.$getQueryString('replyid') || '' // 回复id
  if ((urlFollowupid || urlCommentid) && urlReplyid) {
    // 回复回复和评论回复，定位到页面
    let query = {
      type: 'inquiry-manager-all',
      from: 'notice',
      replyid: urlReplyid
    }
    if (urlFollowupid) {
      query.followupid = urlFollowupid
      if (isMobile) {
        query.tab = 'followupReply'
      } else {
        query.tab2 = 'returnVisite'
      }
    } else if (urlCommentid) {
      query.commentid = urlCommentid
      if (isMobile) {
        query.tab = 'commentReply'
      } else {
        query.tab2 = 'commentContent'
      }
    }
    return query
  }
}

/* function dingTalkAutologon () {
  const { protocol } = window.location
  let currCid = Vue.prototype.$getQueryString('fromdingtalk') || ''
  let path = ''
  // alert(currCid)
  if (!currCid) {
    let fromUrlArr = fromUrl.split('/') || []
    let cidPid = fromUrlArr[2]
    if (cidPid) {
      let newCidPid = Vue.prototype.$decodeBase64(cidPid)
      currCid = newCidPid.split('_')[0] || ''
    }
  }

  if (protocol.indexOf('https') > -1) { // 线上环境
    path = `https://dingtalk_${currCid}.api.westartrack.com/user/dingtalk/login`
  } else { // 测试环境
    path = `http://dingtalk_${currCid}.api.dev.westartrack.com:90/user/dingtalk/login`
  }
  alert(`${path}?from=${encodeURIComponent(fromUrl)}`)

  window.location.href = `${path}?from=${encodeURIComponent(fromUrl)}`
  // alert(window.location.href)
} */
